'use client';

import React, { type CSSProperties } from 'react';

import { pascalCase } from 'text-pascal-case';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { ModuleHeader, ModuleHeaderSize } from '@/components/ModuleHeader';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { type ShopByPriceTileType } from '@/modules/home/types';
import { createCMSTileHref } from '@/modules/home/utils';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  categories: ShopByPriceTileType[];
  moduleName: string;
  campaignTitle?: string;
};

export function ShopByPrice({ campaignTitle, categories, moduleName }: Props) {
  // NB currently this module is NOT powered by the CMS
  // but hard coded here /containers/Home/constants/shopByPrice.ts
  const [, currentUser] = useCurrentUser();
  const userId = currentUser?.id;
  const { sendActivityTrackerEvent: sendATEvent } = useActivityTracker({
    userId,
  });

  function handleClick(category: ShopByPriceTileType, itemPosition: number) {
    const params = {
      moduleName: 'shop_by_price',
      itemClicked: pascalCase(category.title).concat(' ', category.price),
      itemPosition,
      schemaVersion: '3.0',
    };

    sendATEvent(ActivityTrackerEventType.MODULE_CLICK_ACTION, params);
  }

  return (
    <>
      <ModuleHeader title={campaignTitle} size={ModuleHeaderSize.Large} />
      <ul className={styles.tileLayout}>
        {categories.map((category: ShopByPriceTileType, index: number) => {
          return (
            <li className={styles.tileWrapper} key={index}>
              <ExtendedLink
                href={createCMSTileHref(category, moduleName)}
                role="link"
                tabIndex={0}
                onClick={() => handleClick(category, index)}
              >
                <div
                  className={styles.background}
                  style={
                    {
                      '--background': category.backgroundStyle,
                    } as CSSProperties
                  }
                >
                  <div className={styles.titleWrapper}>
                    <span>
                      <span className={styles.title}>{category.title} </span>
                      <span className={styles.price}>{category.price}</span>
                    </span>
                  </div>
                </div>
              </ExtendedLink>
            </li>
          );
        })}
      </ul>
    </>
  );
}
